import { ISearchOffersForHouseCardDesktopResponse } from 'shared/repositories/search-offers/v1/search-offers-for-house-card-desktop';
import { initialState } from 'shared/slices/offers/initialState';
import { EOffersStatus, IOffersDesktop } from 'shared/types/offers';

export const prepareDesktopOffers = (response: ISearchOffersForHouseCardDesktopResponse) => {
  const data = response as IOffersDesktop;

  return {
    data: { ...initialState.data, ...data },
    status: EOffersStatus.Ready,
  };
};
